import { create } from 'zustand';
import type { AnalyticsStore } from './analyticsStore.types';

// Always starts false on the server; only flipped client-side once tracking consent is confirmed.
export const useAnalyticsStore = create<AnalyticsStore>((set) => ({
  isAnalyticsReady: false,
  setIsAnalyticsReady: (isAnalyticsReady) => set({ isAnalyticsReady }),
}));
